import API from 'utils/api';
import { onError } from 'utils/handlers';

/**
 * GET proceso-terminado — consulta el estado de un proceso por descripción.
 * Retorna un array (vacío si no existe el proceso).
 * @param {object} params — e.g. { descripcion: 'Agregar Nombramiento' }
 * @returns {Promise<object[]>}
 */
const getProcesoEnCursoTerminado = async (params) => {
  try {
    const response = await API.get('/catalogos/proceso-terminado/', { params });
    const { data } = response;
    return Array.isArray(data) ? data : (data.results || []);
  } catch (err) {
    onError(err);
  }
  return [];
};

export default getProcesoEnCursoTerminado;
